import { useState } from 'react';
import toast from 'react-hot-toast';
import { useDeleteHireMutation } from '../../../services/hires';

export const REMOVAL_REASONS = [
  'This person is not an employee – board member, investor, advisor, or similar',
  'This person does not work at this company',
  'We connected after they started working at this company',
  'Other',
];

export const useRemoveHireModal = (hire, onClose) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [deleteHire] = useDeleteHireMutation();

  const isOtherSelected = selectedReason === 'Other';
  const canSubmit = selectedReason && (!isOtherSelected || otherReason.trim());

  const handleRemoveHire = () => {
    const reason = selectedReason === 'Other' ? otherReason : selectedReason;
    // Close modal immediately since we're doing optimistic updates
    onClose();
    deleteHire({ ...hire, reason })
      .unwrap()
      .then(() => {
        toast.success('Hire removed successfully');
      })
      .catch(() => {
        toast.error('Failed to remove hire. Please refresh and try again.');
      });
  };

  return {
    selectedReason,
    setSelectedReason,
    otherReason,
    setOtherReason,
    isOtherSelected,
    canSubmit,
    handleRemoveHire,
  };
};
